// extracted by mini-css-extract-plugin
module.exports = {"wfp--theme-dark":"style_wfp--theme-dark__3kBrS","wfp--theme-dark--auto":"style_wfp--theme-dark--auto__hLZig","adhoc-tag":"style_adhoc-tag__36A32","input":"style_input__E3UTb"};